/* eslint-disable jsx-a11y/control-has-associated-label */
import { createElement, ReactChild } from "react";

type Props = {
  defaultValues?: Record<string, any>;
  children?: ReactChild;
  buttonLabel?: string;
  onSubmit: any;
  handleSubmit: any;
  register?: any;
  submitRef: any;
};

export function Form({
  defaultValues,
  buttonLabel = "Submit",
  children,
  onSubmit,
  handleSubmit,
  register,
  submitRef,
  ...rest
}: Props) {
  return (
    <form onSubmit={handleSubmit(onSubmit)} {...rest} ref={submitRef}>
      {Array.isArray(children)
        ? children.map((child) => {
            return child?.props?.name
              ? createElement(child.type, {
                  ...{
                    ...child.props,
                    register,
                    key: child.props.name,
                  },
                })
              : child;
          })
        : children}
      <button ref={submitRef} type="submit" className="hidden" />
    </form>
  );
}
